<template>
  <BasePopup
    :visible="visible"
    popup-class="login-tip-popup"
    :show-close-btn="false"
    @close="handleClose"
  >
    <div class="popup-content-text">{{ langData.loginTip }}</div>
    <div class="popup-actions">
      <div class="popup-confirm-btn" @click="handleLogin"></div>
      <div class="popup-cancel-btn" @click="handleClose"></div>
    </div>
  </BasePopup>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import LanguageHook from '@hooks/language';
import BasePopup from './BasePopup.vue';

// 语言相关
const { langData } = LanguageHook();

// 定义props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
});

// 定义emits
const emit = defineEmits(['close', 'login']);

// 关闭弹窗
const handleClose = () => {
  emit('close');
};

// 处理登录
const handleLogin = () => {
  emit('login');
};
</script>
